module.exports = __webpack_public_path__ + "img/career2.03329978.png";